import { render, staticRenderFns } from "./publishedTasksForView.vue?vue&type=template&id=a6d1f51e&scoped=true&"
import script from "./publishedTasksForView.vue?vue&type=script&lang=js&"
export * from "./publishedTasksForView.vue?vue&type=script&lang=js&"
import style0 from "./publishedTasksForView.vue?vue&type=style&index=0&id=a6d1f51e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d1f51e",
  null
  
)

export default component.exports